import { DICTIONARY } from '../constants';

export const labels: { [key: string]: string } = {
  'company/name': DICTIONARY.LegalNameOfUSCompany,
  'employeeData/email': 'Email',
  'employeeData/firstname': 'First name',
  'employeeData/lastname': 'Last name',
  'employeeData/spouse': 'Spouse',
  'employeeData/dependents': 'Dependents',
  'employmentData/salary': 'Offered salary',
  'employmentData/startDate': 'Start date',
  'employmentData/location': 'Physical working address',
  'employmentData/premiumProcessing': 'Premium processing',
  'foreignNational/employeeId': 'Employee ID',
  ETACaseNumber: 'ETA Case No.',
  prevailingWageCaseNumber: 'PWR Case No.',
  requestedProcess: 'Requested process',
  resumeID: 'Resume',
  USCISReceiptNumber: 'USCIS Receipt No.',
  ReceiptDetails: 'Case Status Details',
  ReceiptHistory: 'Receipt History',
  ViewMoreUSCISReceiptDetails: 'View More...',
  PERMFirstPossibleFilingDate: 'PERM First Possible Filing Date',
  PERMLastPossibleFilingDate: 'PERM Last Possible Filing Date',
  applicantsReceived: 'Applicants Received',
  AOSReceiptNotice: 'AOS Receipt Notice',
  I485JReceiptNotice: 'I-485 Receipt Notice',
  SelectionNoticeNo: 'Selection Notice No.',
};

export default labels;
